module.exports = __webpack_public_path__ + "img/hatford_slide_3.f17eaf25.jpg";